<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-text-field
                v-if="workLocationList.length === 0"
                class="ucFirst body-2"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :outlined="outlined"
                :append-icon="appendIcon"
                :value="value.trim()"
                :name="metadata.name"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="placeholder"
                validate-on-blur
                :data-testid="metadata.name"
                :maxlength="maxLength"
                counter
                :rules="[
                    !required || requiredField(),
                    v => !v || getFormRule('name')(v)
                ]"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="debouncedInput"
            />
            <v-autocomplete
                v-else
                :value="value"
                :items="workLocationList"
                item-text="name"
                item-value="id"
                :outlined="outlined"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="placeholder"
                validate-on-blur
                :rules="[
                    !required || requiredField()
                ]"
                dense
                class="body-2 tz-dropdown pa-0"
                :data-meta-id="metadata.id"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { debounce, find } from 'lodash';
import { ServiceSettings } from '@/enums';

export default {
    name: 'work-location',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    created() {
        this.debouncedInput = debounce(this.emitValue, 500);
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            currentEstSettings: 'services/getCurrentEstSettings',
        }),

        appendIcon() {
            return this.withIcon ? 'fas fa-location-arrow' : '';
        },
        workLocationList() {
            let list = find(this.currentEstSettings, ['setting', ServiceSettings.WORK_LOCATION_LIST]);
            return list ? list.value : [];
        },
        maxLength() {
            return this.metadata && this.metadata.rules && this.metadata.rules.maxLength;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>
